import * as types from '../mutation-types';

const state = {
	roles: [],
	userPermissions: []
}

const actions = {
	fetchAll({ commit }){
		return window.axios.get('/Role/All').then(({ data }) => {
			commit(types.STORE_ROLES, data)
			return data
		})
	},
	updateUserPermissions(_, { userId, permissions }) {
		return window.axios.put('/Role/StaticRoles', {
			financial_file_role_request: permissions,
			user_id: userId	  
		})
	}
}

const mutations = {
	[types.STORE_ROLES](state, roles) { 
		state.roles = roles; 
	}
}

const getters = {
	getRoleById: state => id => state.roles.find(c => c.id === id)
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}